/** Firebase Cloud Storage — instance + URL helpers. */

import { getStorage } from 'firebase/storage';
import { app } from '@/config/firebase';

/** Shared Firebase Storage instance. Use this instead of calling getStorage(app) inline. */
export const storage = getStorage(app);

/** Firebase Storage bucket name from Vite env. */
const BUCKET = import.meta.env.VITE_FIREBASE_STORAGE_BUCKET;

/** Root public URL of the Firebase Storage bucket. */
export const STORAGE_BASE_URL = `https://storage.googleapis.com/${BUCKET}`;

/** NFD spelling first, then the composed character when the two differ. */
function unicodeSpellings(char: string): readonly string[] {
  const decomposed = char.normalize('NFD');
  return decomposed === char ? [char] : [decomposed, char];
}

/** Every mix of composed and decomposed accents. The first name is full NFD. */
function tutorialObjectNames(filename: string): string[] {
  let names = [''];
  for (const char of filename.normalize('NFC')) {
    const spellings = unicodeSpellings(char);
    const next: string[] = [];
    for (const name of names) {
      for (const spelling of spellings) {
        next.push(name + spelling);
      }
    }
    names = next;
  }
  return names;
}

/** Public URL of one Tutorials/ object, keeping the given Unicode spelling. */
function tutorialObjectUrl(objectName: string): string {
  return `${STORAGE_BASE_URL}/Tutorials/${encodeURIComponent(objectName)}.mp4`;
}

/**
 * Public URLs for a tutorial file. Full NFD is first (macOS uploads).
 * Further URLs cover the other accent spellings when the object name is mixed.
 */
export function getTutorialVideoUrlCandidates(filename: string): string[] {
  return tutorialObjectNames(filename).map(tutorialObjectUrl);
}
